<template>
  <Modal title="移至公库" v-model="visible">
    <Form ref="batchMoveUserForm" class="form"
          :label-width="80">
      <Row>
        <Col :span="22">
          <Form-item label="学生">
            <Tag v-for="item in userList" :key="item.id" :name="item.id">
              {{ item.id + ' - ' + item.nickname }}
            </Tag>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingBatchMoveUser" @click="batchMoveUser">确定</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'BatchMoveUserModal',
  props: {
    value: {
      type: Boolean,
      default: true
    },
    userList: {
      type: Array
    },
    successCallback: {
      type: Function
    }
  },
  data() {
    return {
      visible: this.value,
      loadingBatchMoveUser: false,
    }
  },
  methods: {
    batchMoveUser() {
      let self = this
      let idList = self.userList.map(function (element) {
        if (element.uid) {
          return element.uid
        }
        return element.id
      })
      self.loadingBatchMoveUser = true
      self.$http.post('/userList/crmResourceUpdate/batch', {ids: idList.join(',')}).then(function (res) {
        if (res && res.data > 0) {
          self.successCallback()
          self.visible = false
        }
        self.loadingBatchMoveUser = false
      }).catch(function (e) {
        self.visible = false
        self.loadingBatchMoveUser = false
      })
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// BatchMoveUserModal.vue?3d98c6d5